import { redirect } from 'react-router-dom';
import { editorStore } from '@/app/store/store';
import { readStoredAuthToken } from '@/entities/session/model/authStorage';
import { openAuthDialog } from '@/entities/session/model/sessionSlice';
/**
 * 受保护路由的 loader：在渲染前完成登录校验。
 *
 * 未登录时先标记登录弹窗、再抛出重定向；loader 一律早于渲染执行，
 * 因此不存在「上一页已卸载、目标页尚未渲染」的中间空帧，
 * 首页也不会因为地址来回切换而被卸载重建。
 *
 * 判定语义与页面内的 useAuthedQueryEnabled 保持一致：已认证放行；
 * 本地仍持有令牌（会话恢复中）也放行，由页面内查询自行处理过期令牌。
 */
export function requireAuth() {
    const { status } = editorStore.getState().session;
    if (status === 'authenticated' || readStoredAuthToken()) {
        return;
    }
    editorStore.dispatch(openAuthDialog());
    throw redirect('/');
}
